import CategoriesFilter from './CategoriesFilter';

export default CategoriesFilter;
